export default [
    "24 24",
    '<path id="Vector" d="M8 12H12M12 12H16M12 12V16M12 12V8M12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21Z" fill="var(--ci-primary-color, currentColor)"  stroke="#fff" class="stroke-over"  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
]